module.exports = __webpack_public_path__ + "static/img/pineappletangerinebublyburst_th.c374e2e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mixology/cans/pineappletangerinebublyburst_th.png
// module id = 0yPr
// module chunks = 0